import { ServiceProvider } from "../dependencies_management/ServiceProvider";
import { InternalEventData } from "../types/EventsData";
import { InternalEventsSender } from "../utilities/internal_events/InternalEventsSender";
import { AnalyticsPageNameProvider } from "../utilities/page_name/AnalyticsPageNameProvider";
import { WindowLocationWrapper } from "../utilities/window_wrapping/WindowLocationWrapper";
import { AnalyticsTracker } from "./AnalyticsTracker";
import { SECTION_TRACKING_BASE_URL } from "../utilities/internal_events/InternalEventsBaseUrls";
import { InternalPageviewAutomaticTrackingChecker } from "../utilities/internal_events/InternalPageviewAutomaticTrackingChecker";

export class InternalAnalyticsTracker extends AnalyticsTracker<InternalEventData> {
	private readonly analyticsPageNameProvider: AnalyticsPageNameProvider;
	private readonly windowLocation: WindowLocationWrapper;
	private readonly defaultInternalEventsSender: InternalEventsSender;
	private readonly sectionTrackingInternalEventsSender: InternalEventsSender;
	private readonly internalPageviewAutomaticTrackingChecker: InternalPageviewAutomaticTrackingChecker;

	constructor(
		private readonly isUserLicensed: boolean,
		serviceProvider: ServiceProvider
	) {
		super();
		this.analyticsPageNameProvider =
			serviceProvider.getAnalyticsPageNameProvider();
		this.windowLocation = serviceProvider.getWindowLocationWrapper();
		this.defaultInternalEventsSender =
			serviceProvider.getInternalEventsSender();
		this.sectionTrackingInternalEventsSender =
			serviceProvider.getInternalEventsSender(SECTION_TRACKING_BASE_URL);
		this.internalPageviewAutomaticTrackingChecker =
			serviceProvider.getInternalPageviewAutomaticTrackingChecker();
	}

	submitPageView(): void {
		const analyticsPageName = this.getAnalyticsPageName();
		if (
			this.internalPageviewAutomaticTrackingChecker.shouldTrackPage(
				analyticsPageName
			)
		) {
			const { productCode = "" } = this.executionContext;

			const eventData: Record<string, string> = {
				ps: "",
				pg: "",
				cs: analyticsPageName ?? "",
				cg: analyticsPageName ?? "",
				lc: this.isUserLicensed.toString(),
				pc: productCode,
			};

			this.sectionTrackingInternalEventsSender.sendEvent(eventData);
		}
	}

	submitEvent(eventData: InternalEventData): void {
		const pageName = this.getAnalyticsPageName() ?? "";
		const { productCode = "" } = this.executionContext;
		const urlPath = this.windowLocation.pathWithQueryString;

		const {
			component = "",
			section = "",
			action = "",
			extra = "",
			count = "",
		} = eventData;

		const formattedEventData = {
			lc: this.isUserLicensed.toString(),
			pc: productCode,
			pt: urlPath,
			pn: pageName,
			en: component,
			ec: section,
			ea: action,
			ee: extra,
			ect: count,
		};

		this.defaultInternalEventsSender.sendEvent(formattedEventData);
	}

	private getAnalyticsPageName(): string | undefined {
		return this.analyticsPageNameProvider.providePageName(
			this.executionContext
		);
	}
}
